import { render } from "./TableActionsMandatPSU.vue?vue&type=template&id=6f748560&scoped=true"
import script from "./TableActionsMandatPSU.vue?vue&type=script&lang=js"
export * from "./TableActionsMandatPSU.vue?vue&type=script&lang=js"

import "./TableActionsMandatPSU.vue?vue&type=style&index=0&id=6f748560&scoped=true&lang=css"

import exportComponent from "/data/opt/gitlab-runner/working-directory/podman-stable_v4.8.1/corpo/crp-cardex-webapp/src/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f748560"]])

export default __exports__